import { render, staticRenderFns } from "./Accommodatie.vue?vue&type=template&id=09e1789e&"
import script from "./Accommodatie.vue?vue&type=script&lang=js&"
export * from "./Accommodatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports